import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createDiary } from "../../api/CALENDAR/calendar";

export const useCreateDiary = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createDiary,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["calendarEvents"] });
    },
  });
};
